import { render, staticRenderFns } from "./update-option-modal.vue?vue&type=template&id=665ab65b&scoped=true"
import script from "./update-option-modal.vue?vue&type=script&lang=js"
export * from "./update-option-modal.vue?vue&type=script&lang=js"
import style0 from "./update-option-modal.vue?vue&type=style&index=0&id=665ab65b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665ab65b",
  null
  
)

export default component.exports